module.exports = __webpack_public_path__ + "img/pixing_xc18.cb79619f.jpg";